import { LinearProgress } from './Linear/LinearProgress.js';
import { CircularProgress } from './Circular/CircularProgress.js';
import { StarProgress } from './Star/StarProgress.js';
import { DotProgress } from './Dots/DotProgress.js';

var Progress = {
  Linear: LinearProgress,
  Circular: CircularProgress,
  Star: StarProgress,
  Dots: DotProgress
};

export { CircularProgress, DotProgress, LinearProgress, Progress, StarProgress };
